/* eslint-disable react-hooks/exhaustive-deps */
import { Card, Col, Container, Row } from 'react-bootstrap'
import Carousel from 'react-multi-carousel'
import { useId, useRef, useEffect } from 'react'
import DiscoveryIcon from '@assets/icons/discovery.svg'
import IniciativeIcon from '@assets/icons/iniciatives.svg'
import TrainingIcon from '@assets/icons/training.svg'
import AdaptIcon from '@assets/icons/adapt.svg'
import ManagedServicesIcon from '@assets/icons/managed-services.svg'
import { setHorizontalScrollToElement } from 'src/@shared/functions/format'

import { Carousel1ResProps } from '@atk/components/carousel/Carousel1/Carousel1'
import Icon from '@atk/components/icon'

import styles from './SlideOffer.module.scss'

const responsive: Carousel1ResProps = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 1200 },
        items: 3.5,
    },
    desktop: {
        breakpoint: { max: 1199.99, min: 992 },
        items: 2.5,
    },
    tablet: {
        breakpoint: { max: 991.99, min: 768 },
        items: 2,
    },
    mobile: {
        breakpoint: { max: 767.99, min: 0 },
        items: 1.5,
    },
}

export type SlideCasperState = {
    title: string
    desc: string
}

const getIcon = (index: number) => {
    switch (index) {
        case 0:
            return DiscoveryIcon.src
        case 1:
            return IniciativeIcon.src
        case 2:
            return TrainingIcon.src
        case 3:
            return AdaptIcon.src
        case 4:
            return ManagedServicesIcon.src
        default:
            return ''
    }
}

const slide = [
    {
        title: 'Discovery',
        desc: 'Blockchain has many use cases, and not all are immediately apparent. We will partner with you from day one to understand your IT environment and assess and validate your goals while exploring whether there are additional areas in which blockchain can drive successful outcomes that positively impact your bottom line.',
    },
    {
        title: 'Aligned Incentives',
        desc: 'Our aligned incentive model means we care about your success. Unlike a typical consultancy, we’ll take an active role until your goals are met.',
    },
    {
        title: 'Training and Education',
        desc: 'We provide training to your entire team, from developers to management, which allows you to more efficiently and effectively discover areas where the Casper blockchain can bring additional business value.',
    },
    {
        title: 'Adapt and Enhance',
        desc: 'When we build and design bespoke software for clients, we always keep scalability and upgradability in mind. Even after deployment, features such as smart contracts can be upgraded to scale into evolving business needs.',
    },
    {
        title: 'Managed Services',
        desc: 'Casper Labs provides ongoing, sustained support and maintenance for organizations building on the Casper protocol. We offer both large and small engagement models to fit your individual needs.',
    },
]

export default function SlideOffer() {
    const key = useId()
    const ref = useRef(null)
    const titleClass = `${styles.sectionTitleSlide} mb-5`
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const carousel = ref.current as any

    useEffect(() => {
        if (carousel) {
            setHorizontalScrollToElement(carousel.containerRef.current)
        }
    }, [carousel])

    return (
        <section className="slideOffer p-0">
            <Container>
                <Row>
                    <Col lg={12}>
                        <h2 className={titleClass}>
                            What we <span className="text-red">offer</span>
                        </h2>
                    </Col>
                </Row>
            </Container>
            <div className={styles.cardsContainer}>
                <Carousel ref={ref} responsive={responsive} arrows={false} swipeable={false} draggable={false}>
                    {slide &&
                        slide.map((p: SlideCasperState, index: number) => (
                            <div key={key + index} className="p-3">
                                <Card className={'carouselCard' + (' carouselCard' + index)}>
                                    <Card.Body className={styles.cardBody}>
                                        <div className="d-flex flex-column justify-content-start h-100">
                                            <div className="mb-5">
                                                <Icon source={getIcon(index)} />
                                            </div>

                                            <div className="">
                                                <h3 className="cardTitle mb-4">{p.title}</h3>
                                                <Card.Text className="cardContent">{p.desc}</Card.Text>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </div>
                        ))}
                </Carousel>
                <div className="carouselScrollLine"></div>
            </div>
        </section>
    )
}
